export const ssoConfig = {
  appId: 26,
  sso: {
    tokenExpiresInMin: 2,
    timeBeforeCallingRefreshInSecs: 15
  },
};
